<template>
  <div class="sidebar"
       :style="sidebarStyle"
       :data-color="backgroundColor"
       :data-image="backgroundImage"
       :data-active-color="activeColor">

    <div class="sidebar-wrapper mb-auto pb-0" ref="sidebarScrollArea">
      <div class="logo">
        <!-- <img src="/static/img/icon + logo.svg" class="ml-3 mr-5"/> -->
        <span>
          <h1 class="ml-3 mt-1">
            <i class="fas fa-skull-crossbones ml-2"/>
            <i class="fas fa-skull-crossbones ml-2"/>
            <i class="fas fa-skull-crossbones ml-2"/>
            <i class="fas fa-skull-crossbones ml-2"/>
          </h1>
        </span>
        <!-- <a class="logo-mini"
           href="https://www.creative-tim.com/product/vue-light-bootstrap-dashboard-pro">
          <div class="logo-img">
              <img :src="logo" alt="logo">
          </div>
        </a>
        <a href="" class="simple-text logo-normal">
          {{ title }}
        </a> -->
      </div>
      <slot>
        
      </slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks"
                        :key="link.name + index"
                        :link="link">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>

      </ul>

      <div v-if="showVersion">
        <small v-tooltip.top-center="tooltip" style="bottom: 0; position: absolute"> v{{ version }} </small>
      </div>

    </div>
  </div>
</template>
<script>
  export default {
    name: 'sidebar',
    data () {
      return {
        showVersion: true,
        version: process ? process.env.VUE_APP_VERSION : 'dev',
        tooltip: process ? process.env.VUE_APP_RELEASE_NOTES.split('<br><br><br>')[0]
                            + `<br><br>---<br> <small><i>Add <b>/version</b> or <b>/v</b> in the URL to see full logs</i></small>`
                         : 'dev'
      }
    },
    props: {
      title: {
        type: String,
        default: 'Incentify'
      },
      backgroundColor: {
        type: String,
        default: 'black',
        validator: (value) => {
          let acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      backgroundImage: {
        type: String,
        default: ''
      },
      activeColor: {
        type: String,
        default: 'success',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      logo: {
        type: String,
        default: '/static/img/vue-logo.png'
      },
      sidebarLinks: {
        type: Array,
        default: () => []
      },
      autoClose: {
        type: Boolean,
        default: true
      }
    },
    provide () {
      return {
        autoClose: this.autoClose,
      }
    },
    computed: {
      sidebarStyle () {
        return {
          backgroundImage: `url(${this.backgroundImage})`
        }
      }
    },
    methods: {
      async initScrollBarAsync () {
        await import('perfect-scrollbar/dist/css/perfect-scrollbar.css')
        const PerfectScroll = await import('perfect-scrollbar')
        if (this.$refs.sidebarScrollArea) { // added because sometimes at login it's undefined
          PerfectScroll.initialize(this.$refs.sidebarScrollArea)
        }
      },
    },
    mounted () {
      this.initScrollBarAsync()
    },
    beforeDestroy () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
    }
  }

</script>
<style>
  @media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }
</style>
